const o=(o,t,c)=>c?[t,o]:[o,t];export{o as getOrderedProductInformationFields};
